import * as firebase from "firebase/app";

import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: "test",
    authDomain: "gtconnect2019.firebaseapp.com",
    databaseURL: "https://gtconnect2019.firebaseio.com",
    projectId: "gtconnect2019",
    storageBucket: "gtconnect2019.appspot.com",
    messagingSenderId: "937026504053"
};

firebase.initializeApp(firebaseConfig);

export default firebase;